import { queryOptions } from '@tanstack/react-query';

import { api, unwrap } from '@/shared/api/client';
import { STALE } from '@/shared/api/stale';

export const authKeys = {
  all: ['auth'] as const,
  sessions: () => ['auth', 'sessions'] as const,
};

/** The signed-in user's active sessions, current first (GET /me/sessions). */
export const mySessionsQuery = queryOptions({
  queryKey: authKeys.sessions(),
  queryFn: () => unwrap(api.GET('/me/sessions')),
  staleTime: STALE.record,
});
